import { render, staticRenderFns } from "./DigitalLabel.vue?vue&type=template&id=9780e5f0&scoped=true&"
import script from "./DigitalLabel.vue?vue&type=script&lang=js&"
export * from "./DigitalLabel.vue?vue&type=script&lang=js&"
import style0 from "./DigitalLabel.vue?vue&type=style&index=0&id=9780e5f0&prod&lang=scss&scoped=true&"
import style1 from "./DigitalLabel.vue?vue&type=style&index=1&id=9780e5f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780e5f0",
  null
  
)

export default component.exports